// extracted by mini-css-extract-plugin
export default {"ToDos":"TaskList_ToDos__FUVQ6"};